import gsap from 'gsap';
import Sniffer from 'sniffer';
import imagesLoaded from 'imagesloaded';
import VirtualScroll from 'virtual-scroll';

import { math, app } from './store';

export default class Scroll {
  constructor() {
    this.vs = new VirtualScroll();

    this.vs.options.touchMultiplier = 2.5;
    this.vs.options.mouseMultiplier = 0.45;
    this.vs.options.firefoxMultiplier = 90;

    this.vs.options.passive = true;
    this.vs.options.limitInertia = false;

    this.header = document.querySelector('header');
    this.section = document.querySelector('article');

    this.data = {
      last: 0,
      ease: 0.1,
      current: 0,
    };
  }

  render = () => {
    if (app.loading === true) return;

    this.data.last = math.lerp(this.data.last, this.data.current, this.data.ease);

    this.data.abs = Math.abs(this.data.last);

    if (this.data.abs < 0.1) {
      this.data.last = 0;
    }

    if (app.contact === false) {
      this.header.style.transform = `translate3d(0px, ${this.data.last}px, 0px)`;
    }

    this.section.style.transform = `translate3d(0px, ${this.data.last}px, 0px)`;
  }

  calc = (e) => {
    this.data.current += e.deltaY;
    this.data.current = Math.max((this.bounding.height - window.innerHeight) * -1, this.data.current);
    this.data.current = Math.min(0, this.data.current);
  }

  resize = () => {
    if (Sniffer.isDevice) {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    this.bounding = this.section.getBoundingClientRect();
  }

  events = () => {
    window.addEventListener('resize', this.resize, { passive: true });
  }

  on = () => {
    this.vs.on(this.calc);
    gsap.ticker.add(this.render);
  }

  off = () => {
    this.vs.destroy();
    gsap.ticker.remove(this.render);
    window.removeEventListener('resize', this.resize, { passive: true });
  }

  enable = () => {
    this.vs.on(this.calc);
  }

  disable = () => {
    this.vs.off();
  }

  init = () => {
    imagesLoaded(this.section, () => {
      this.events();
      this.resize();
      this.on();
    });
  }
}
